export class ArrayUtils {

  public static union(...arrays: any[][]): any[] {
    return [...new Set(arrays.reduce((accum: any[], array: any[]) => accum.concat(array), []))];
  }

}
